export const can = (permission, resource = null) => {
  const gate = {
    permission,
    result: false,
  };

  if (window.userPermissions && window.userPermissions[permission]) {
    gate.type = 'global';
    gate.result = true;
  }

  if (resource && resource.can && resource.can[permission]) {
    gate.type = 'global';
    gate.result = true;
  }

  return gate.result;
};

export const route = {
  people: (url = '') => (
    `${window.routes.people}${url}`
  ),

  projects: (url = '') => (
    `${window.routes.projects}${url}`
  ),

  techops: (url = '') => (
    `${window.routes.techops}${url}`
  ),

  // Shortcut routes:
  profile: (user) => (
    route.people(`/users/${user.id}`)
  ),

  project: (project) => (
    route.projects(`/projects/${project.id}`)
  ),

  incident: (incident) => (
    route.techops(`/incidents/${incident.id}`)
  ),

  deployment: (deployment) => (
    route.techops(`/deployments/${deployment.id}`)
  ),

  system: (system) => (
    route.techops(`/systems/${system.id}`)
  ),

  repository: (repository) => (
    route.techops(`/repositories/${repository.id}`)
  ),

  technology: (technology) => (
    route.techops(`/technologies/${technology.id}`)
  ),

  product: (product) => (
    route.projects(`/products/${product.id}`)
  ),
};

export const navigate = (url, rrNavigate) => {
  // Is the url within the same domain?
  if (url.indexOf(window.location.origin) === 0) {
    // Yes, so we can use rrNavigate:
    rrNavigate(url.replace(window.location.origin, ''));
    console.log('using rrNavigate', url);
    return;
  }

  console.log('using window.location.href', url);
  // No, so we need to use window.location.href:
  window.location.href = url;
};
